module.exports = __webpack_public_path__ + "img/E-commerce.e2af2d00.png";